import "./App.css";
import { NavigationRoutes } from "./routes/NavigationRoutes";

function App() {
  return (
    <div className="App">
      <NavigationRoutes />
    </div>
  );
}

export default App;
